<template>
  <v-sheet
    height="128"
    width="160"
    elevation="3"
    v-bind="$attrs"
  >
    <div class="display-simulation-kb">
      <div class="text-big">5</div>
      <div class="text-small">Euro</div>
      <img style="position: absolute; top: 8px; left: 8px;" src="data:image/png;base64,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">
      <contenteditable
        tag="div"
        class="text-content"
        v-model="val"
        :contenteditable="selected && editable"
      ></contenteditable>
    </div>
  </v-sheet>
</template>

<script>
export default {
  name: 'DisplayKindKB',
  props: ["value", "selected", "editable"],
  data () {
    return {
      val: this.value
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        this.val = newValue
      }
    },
    val (newVal) {
      this.$emit("input", newVal)
    }
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
.display-simulation-kb
  width: 160px
  height: 128px
  position: relative
  background-color: black
  color: white
  font-family: Arial
  font-size: 16px
  line-height: 100%
  overflow: hidden
  margin-right: 0

  > div
    position: relative

  .text-content
    position: absolute
    top: 51px
    text-align: center
    width: 100%
    line-height: 100%
    white-space: nowrap

  .text-big
    font-size: 48px
    position: absolute
    right: 62px
    bottom: 84px
    line-height: 100%
    margin-bottom: -3px

  .text-small
    font-size: 24px
    bottom: -22px
    left: 102px

</style>
